export default __webpack_public_path__ + "static/media/ruppe_icon.145ca97b.svg";